<template>
  <div class="main">
    <div class="wrapPortable Indica ICo">
      <h1 class="indH1">Session collective</h1>
    </div>
    <div class="session_col tabcontent">
      <div class="sessionCo">
        <div class="participants_define">
            <div class="participants_define_search" @click="pushPush()">
                <div class="rondSearch"><img src="../assets/logo/logo-collective.png" alt="logo session collective"></div>
                <autocomplete :source="arraySearch" :maxlength="8" id="participant_search" name="participant_search" v-model="selection" :placeholder="'Rechercher un participant'" >
                </autocomplete>
                <div class="rond_loupe"><img src="../assets/logo/logo-loupe-search.png"></div>
            </div>
            <div class="afficheParticipant">
              <ul v-if="arraySelectionne !== []" class="ul-atteste">
                <div class="column1" v-if="arrayPair !== []">
                    <li v-for="koko in arrayPair" :key="koko">
                      <div :id="'cercle'+koko" :class="['rond', 'rondCo']" @click.prevent="cour = arraySearch[koko-1].name ">
                        {{ lettre(koko) }} 
                      </div>
                      {{ afficheNom(arraySearch[koko-1].name, koko)}}
                      </li>
                </div>
                <div class="column2" v-if="arrayImpair !== []">
                  <li v-for="koko in arrayImpair" :key="koko">
                      <div :id="'cercle'+koko" :class="['rond', 'rondCo']" @click.prevent="cour = arraySearch[koko-1].name ">
                        {{ lettre(koko) }} 
                      </div>
                      {{ arraySearch[koko-1].name }}
                  </li>
                </div>
              </ul>
            </div>
        </div>
        </div>
        <div class="participants_define2">
            <div class="participants_define3">
                <input type="text" v-model="cour" class="sessionValid">
                <button class="validSession" @click.prevent="atteste()">Valider ma Session</button>
            </div>
            <button type="button" class="submitQuestionnaire seCosubmit" @click="postForSession()">Demarrer la Session</button>
        </div> 
      
    </div>
  </div>
</template>


<script>
import Autocomplete from 'vuejs-auto-complete';
import { User } from "../controller/user.js";
import { hostUrl } from "../_helpers/global_var";


//définir une fonction qui va me permettre de ne pas me faire passer par lenght afin d'obtenir la longueur de mmon tableau d'objects
//define a function which will allow me not to pass by lenght in order to obtain the length of mmon array of objects
Object.size = function(obj) {
    var size = 0, key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

const axios = require('axios').default;
const date = new Date();
const month = ["Janvier", "Fevrier", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Decembre"];

export default {
  name: "Session_Collective",
  data() {
    return {
      user: JSON.parse(localStorage.user)|| [],
      arrayAll: [],
      arraySearch: [{
            id:2,
            name:'John'
        },
        {
            id:3,
            name:'Do'
      }],
      titreSession: {
          date: '',
          nb_Partcipant: '',
          nomCoach: '',
          participants: [''],
      },
      cour: 'session du '+date.getDate()+' '+month[date.getMonth()]+' '+date.getFullYear(),
      arraySelectionne: [],
      selection: "",
      arrayPair: [],
      arrayImpair:[],
    };
  },
  created(){
    if (typeof(localStorage.user) !== undefined && localStorage.length > 1 ){
      try {
        JSON.parse(localStorage.user);
        this.user = JSON.parse(localStorage.user);
      } catch (error) {
        this.$router.push({ name: 'connexion' });
      }
    }
    this.searchAll();
    console.log(this.arrayAll, this.arraySearch);
    this.lastChoice = this.cour;
    if(this.arrayAll !== []){
      this.defineSearch();
      console.log(this.arraySelectionne);
    }
    
  },
  components: {
    Autocomplete,
  },
  methods: {
    searchAll(){
      axios
       .get(hostUrl+'/allSalarie/'+this.user.nom_entreprise.toLowerCase())
       .then(response => localStorage.listeSalarie = JSON.stringify(response.data))
       .catch(error => console.log('ko = '+error));  
       this.arrayAll = JSON.parse(localStorage.listeSalarie);
       
    },
    defineSearch(){
      this.arraySearch = [];
       let i =1;
       JSON.parse(this.arrayAll).forEach(element => {
          this.arraySearch[i-1] = {'id': i, 'name': element.nom+' '+element.prenom, 'salarie_id': element.salarie_id}
          i++;         
       });
       //console.log(this.arrayAll, this.arraySearch);
    },
    lettre(id){
      let nom  = 'X';
      this.arraySearch.forEach(element => {
      if (element.id  == id){
        nom = element.name.trim().substr(0, 1).toUpperCase();
      }
      });
      return nom;
    },
    atteste(){
      if(this.cour !== null){
      var id2 = 1;
      //console.log(this.cour);
      this.arraySearch.forEach(element => {
      if (element.name  == this.cour){
           id2 = element.id;
        }
      });

      let cercle = document.getElementById('cercle'+id2);

      if (cercle.className == "selected rond rondCo"){
        cercle.className = "rond rondCo";
      }else{
        cercle.className = "selected rond rondCo"
      }
      }
     
    },
    whoAreYou(string, id=null){
      if (id == null){
        this.arraySearch.forEach(element => {
          if (element.name  == string){
            //console.log(element.id);
            let id = element.id
            return id;
          }
        });
      }else{
        this.arraySearch.forEach(element => {
          if (element.id == string){
            return element.name;
          }
        });
      }
      
    },
    afficheNom(nom, id){
      this.lastChoice = nom;
      return nom;
    },
    pushPush(){
      if (this.selection !== ""){
      if (this.verifArray(this.arraySelectionne, this.selection) === false){
        this.arraySelectionne.push(this.selection);
        this.pairImpair(this.arraySelectionne);
        this.arraySearch.forEach(element => {
          if (element.id == this.selection){
            return this.cour = String(element.name);
          }
        });
        
      //console.log(this.cour, this.arrayPair);
      }
      }
    },
    verifArray(array, selector){
      for (let i = 0; i < Object.size(array); i++) {
        if (selector == array[i]){
          return true;
        }
    }
    return false;
    },
    pairImpair(array){
        this.arrayImpair = [];
        this.arrayPair = [];

        for(let i = 0; i < Object.size(array); i++){
          if ( i % 2 == 0){
            this.arrayPair.push(array[i]);
          }else{
            this.arrayImpair.push(array[i]);
          }
      }
    },
    postForSession(){
      var arrayFinale= [];
      let valide = document.getElementsByClassName('selected rond rondCo');
        for(let i = 0; i < Object.size(valide); i++){
            let ida = this.arraySearch[valide[i].id.slice(6)-1].salarie_id;
            arrayFinale.push({'salarie_id' : ida});
          }
      localStorage.participantsCo = JSON.stringify(arrayFinale);
      this.$router.push({ name: 'Session_Individuelle' });
    }
  },

};
</script>
<style>
  .session_col{
    width: 100%;
  }
  .participants_define{
    height: 50vh;
  }
  .participants_define_search{
    height: 45px;
  }
  .ICo{
    margin: 0;
  }
.ul-atteste{
  list-style-type: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
}
.column1, .column2{
  width: 50%;
}
.ul-atteste li{
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.rondCo:hover{
  background-color: #473334;
  color: white;
}
.rondCo{
  margin-right: 15px;
}
.seCosubmit{
  width: 100%;
  margin-right:auto;
  margin-left: auto;
}
.autocomplete__results__item{
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/SessionCollective.vue